interface ChartTooltipProps {
  readonly assetName: string;
  readonly value: string;
  readonly color: string;
}

export function ChartTooltip({ assetName, value, color }: ChartTooltipProps) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "flex-start",
        borderRadius: 2,
        padding: "4px 8px",
        color,
        background: "rgba(8, 9, 11, 0.85)",
        border: `1px solid ${color}55`,
        fontFamily: "var(--f-mono)",
        pointerEvents: "none",
        whiteSpace: "nowrap",
      }}
    >
      {assetName ? (
        <span style={{ fontSize: 10, opacity: 0.75, letterSpacing: "0.14em" }}>
          {assetName.toUpperCase()}
        </span>
      ) : null}
      <span style={{ fontSize: 14, fontWeight: 500 }}>{value}</span>
    </div>
  );
}
